import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let IconBox = class IconBox extends Vue {
    LightenDarkenColor(col, amt) {
        let usePound = false;
        if (col[0] === "#") {
            col = col.slice(1);
            usePound = true;
        }
        const num = parseInt(col, 16);
        let r = (num >> 16) + amt;
        if (r > 255) {
            r = 255;
        }
        else if (r < 0) {
            r = 0;
        }
        let b = ((num >> 8) & 0x00ff) + amt;
        if (b > 255) {
            b = 255;
        }
        else if (b < 0) {
            b = 0;
        }
        let g = (num & 0x0000ff) + amt;
        if (g > 255) {
            g = 255;
        }
        else if (g < 0) {
            g = 0;
        }
        return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }
};
IconBox = __decorate([
    Component({
        props: ["footer", "iconBGColor1", "iconBGColor2"],
        data() {
            return {
                gradientValue: "",
            };
        },
        computed: {
            iconBGStyle() {
                return {
                    color: "white",
                    backgroundImage: "linear-gradient(60deg, " +
                        this.$props.iconBGColor1 +
                        ", " +
                        this.$props.iconBGColor2 +
                        ")",
                    boxShadow: "0 12px 20px -10px " +
                        this.$props.iconBGColor1 +
                        "73, 0 4px 20px 0 " +
                        this.$props.iconBGColor1 +
                        "73, 0 7px 8px -5px " +
                        this.$props.iconBGColor1 +
                        "73",
                };
            },
        },
    })
], IconBox);
export default IconBox;
